import { gql } from '@apollo/client';
import Fragments from '../fragments';

export const GET_APPLICATION_COMMENTS = gql`
  query applicationComments($id: ID!, $is_comment: Boolean, $first: Int!, $page: Int) {
    applicationComments(id: $id, is_comment: $is_comment, first: $first, page: $page) {
      paginatorInfo {
        count
        currentPage
        firstItem
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
      data {
        id
        content
        user {
          ...UserInformation,
        }
        # created_at
        # created_at
        # is_reply
      }
    }
  }
  ${Fragments.userInfo}
`;

export const GET_APPLICATION_MESSAGES = gql`
  query applicationMessages($application: ID!, $first: Int!, $page: Int) {
    applicationMessages(application: $application, first: $first, page: $page) {
      paginatorInfo {
        count
        currentPage
        firstItem
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
      data {
        message
        user_id
        created_at
      }
    }
  }
`;

export const APPLICATION_REVIEW_STATUS_QUERY = gql`
  query applicationReviewStatus($id: ID!) {
    applicationReviewStatus(id: $id) {
      opportunity {
        ...opportunityMini
      }
      status
    }
  }
  ${Fragments.opportunityMini}
`;

export const APPLICATION_SUBMISSION_STATUS_QUERY = gql`
  query applicationSubmissionStatus($id: ID!) {
    applicationSubmissionStatus(id: $id) {
      opportunity {
        ...opportunityMini
      }
      status
    }
  }
  ${Fragments.opportunityMini}
`;

export const APPLICATION_REGISTRATION_STATUS_QUERY = gql`
  query applicationRegistrationStatus($id: ID!) {
    applicationRegistrationStatus(id: $id) {
      name
      opportunity {
        ...opportunityMini
      }
      payment {
        title
        cost
        code
        currency
        slots
        filled_slots
        description
      }
      payment_status
      payment_info {
        receipt
      }
      status
    }
  }
  ${Fragments.opportunityMini}
`;

export const APPLICATION_STATUS_QUERY = gql`
  query applicationStatus($id: ID!) {
    applicationStatus(id: $id) {
      name
      opportunity {
        ...opportunityMini
      }
      payment {
        title
        cost
        code
        currency
        slots
        description
      }
      payment_status
      payment_info  {
        receipt
      }
      status
    }
  }
  ${Fragments.opportunityMini}
`;

export const APPLICATION_REVIEWED = gql`
  query($id: ID!) {
    isApplicationReviewed(id: $id)
  }
`;